/* eslint-disable react/prop-types */
import { Box, Button, Flex, FormControl, FormErrorMessage, Input, Text } from '@chakra-ui/react';
import { Form, Formik, useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ModalLoading from '../../components/Loader/ModalLoader.jsx';
import { urlNavigate } from '../../helper/utils/navigation.js';
import { doCheckEmailOrPhone } from '../../redux/waiver/waiver.actions.js';
import FormLayoutProvider from '../layout/FormLayoutProvider.jsx';
import { WaiverRegistrationSchema } from './hooks/validation.js';

function FormEmailCheck() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { loadingCheckPhone = false } = useSelector((s) => s?.waiver);

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        onSubmit: (values) => dispatch(doCheckEmailOrPhone(values, navigate)),
        validationSchema: WaiverRegistrationSchema,
    });

    return (
        <div>
            <FormLayoutProvider>
                <ModalLoading loading={loadingCheckPhone} />
                <Formik onSubmit={formik.handleSubmit} initialValues={formik.initialValues}>
                    <Form>
                        <>
                            <p style={{ fontSize: '1.5em' }}>{t('waiver_existing_sure')}</p>
                            <br />
                            <FormControl isInvalid={!!formik?.errors.email && formik?.touched.email}>
                                <Input size='lg' id='email' name='email' type='email' py={7} onChange={formik.handleChange} value={formik?.values?.email ?? ''} placeholder={t('please_fill_email')} />
                                <FormErrorMessage>{formik?.errors.email}</FormErrorMessage>
                            </FormControl>
                            <Box my={2}>
                                <Button width='100%' type='submit' colorScheme='red' py={7}>
                                    {t('next')}
                                </Button>
                                <Flex
                                    mt={4}
                                    w='full'
                                    alignItems='center'
                                    justifyContent='center'
                                    flexDirection={{
                                        base: 'column',
                                        md: 'row',
                                    }}
                                    gap={2}>
                                    <Button w='full' py={7} onClick={() => navigate(urlNavigate('membership'))}>
                                        {t('buy_membership')}
                                    </Button>
                                    <Text display={{ base: 'none', md: 'inline' }} w='35%' textAlign='center' color='gray.400'>
                                        - {t('or')} -
                                    </Text>
                                    <Button w='full' py={7} onClick={() => navigate(`${urlNavigate('online-sales', 'home')}`)}>
                                        {t('buy_ticket')}
                                    </Button>
                                </Flex>
                            </Box>
                        </>
                    </Form>
                </Formik>
            </FormLayoutProvider>
        </div>
    );
}

export default FormEmailCheck;
